"use client";

import { IIpoListAPIResponse } from "../../interfaces/IpoList.interface";
import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import IpoListWrapper from "../IpoList/IpoListWrapper";
import IpoTitle from "../IpoTitleWithDescription/IpoTitle";

type IpoClientProps = {
  mainboardInitial: IIpoListAPIResponse;
  smeInitial: IIpoListAPIResponse;
  authoringData?: IpoAuthoringDataType;
};

const IpoClient = ({
  mainboardInitial,
  smeInitial,
  authoringData,
}: IpoClientProps) => {
  return (
    <>
      <IpoTitle
        ipoTitle={authoringData?.ipoTitle ?? "IPO"}
        ipoDescription={authoringData?.signInText}
        ipoType={authoringData?.ipoType ?? "upcoming"}
        defaultVariant={false}
        mainboardCount={mainboardInitial.data.totalcount}
        smeCount={smeInitial.data.totalcount}
        headingLevel={authoringData?.headingLevel}
      />
      <IpoListWrapper
        componentLink={authoringData?.componentLink ?? "ipo"}
        ipoTitle={authoringData?.ipoTitle ?? "IPO"}
        mainboardTitle={authoringData?.mainboardTitle ?? "Mainboard"}
        smeTitle={authoringData?.smeTitle ?? "SME"}
        viewAllText={authoringData?.viewAllText ?? "View all"}
        biddingPeriodText={authoringData?.biddingPeriodText ?? "Bidding period"}
        minimumInvestmentText={
          authoringData?.minimumInvestmentText ?? "Minimum investment"
        }
        bidPriceText={authoringData?.bidPriceText ?? "Issue price"}
        listingDateText={authoringData?.listingDateText ?? "Bidding Period"}
        listingGainText={authoringData?.listingGainText ?? "Bid Range"}
        pageType={authoringData?.pageType ?? "ipo"}
        showMoreCtaText={authoringData?.showMoreCtaText ?? "Show more"}
        paginationLimit={authoringData?.paginationLimit ?? "20"}
        ipoType={authoringData?.ipoType ?? "upcoming"}
        apiErrorDesc={authoringData?.apiErrorDesc ?? "No IPOs found."}
        fetchApiDataErrorDesc={
          authoringData?.fetchApiDataErrorDesc ??
          "Unable to fetch IPOs right now."
        }
        tbaText={authoringData?.tbaText ?? "TBA"}
        signInText={authoringData?.signInText}
        redirectToPdpBaseUrl={authoringData?.redirectToPdpBaseUrl}
        viewAllRedirectUrl={authoringData?.viewAllRedirectUrl}
        openInNewTab={authoringData?.openInNewTab}
        mainboardInitial={mainboardInitial}
        smeInitial={smeInitial}
      />
    </>
  );
};

export default IpoClient;
